(() => {
  'use strict';
  if (window.AWMonAtelierEntrySourceP1?.version) return;

  const VERSION = '1.6.0';
  const PARAM = 'aw_entry';
  const STORAGE_KEY = 'aw_mon_atelier_entry_v1';
  const ALLOWED = new Set([
    'thank_you',
    'order_status',
    'order_action',
    'order_index',
    'customer_profile',
    'account_menu',
    'login_return'
  ]);
  const NOTICE_COPY = {
    thank_you: 'Commande confirmée — retrouvez ici vos achats et leur suivi AW.',
    order_status: 'Vous arrivez depuis le suivi de cette commande.',
    order_action: 'Vous arrivez depuis les actions de cette commande.',
    order_index: 'Vous arrivez depuis votre historique de commandes.',
    customer_profile: 'Vous arrivez depuis votre profil client.',
    account_menu: 'Vous arrivez depuis votre compte client.',
    login_return: 'Connexion réussie — vos achats peuvent maintenant être relus.'
  };

  const getEntry = () => {
    try {
      const value = new URLSearchParams(window.location.search).get(PARAM) || '';
      return ALLOWED.has(value) ? value : '';
    } catch (_) {
      return '';
    }
  };

  const track = (entry) => {
    if (!entry || document.documentElement.dataset.awMonAtelierEntryTracked === entry) return;
    document.documentElement.dataset.awMonAtelierEntryTracked = entry;
    document.documentElement.dataset.awMonAtelierEntry = entry;
    const root = document.querySelector('[data-aw-atelier]');
    if (root) root.dataset.awEntry = entry;
    try { window.sessionStorage.setItem(STORAGE_KEY, entry); } catch (_) {}
    try { window.AWAnalytics?.track?.('mon_atelier_postpurchase_entry', { entry }); } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent('aw:mon-atelier-entry', { detail: { entry } }));
    } catch (_) {}
  };

  const applyLoginReturn = (entry) => {
    const source = entry || 'login_return';
    const returnTo = `/pages/mon-atelier-airsoft?aw_entry=${encodeURIComponent(source)}#aw-achats-suivi`;
    const href = `/customer_authentication/login?return_to=${encodeURIComponent(returnTo)}`;
    document.querySelectorAll('[data-aw-postpurchase-empty] a[href="/account"]').forEach((link) => {
      link.setAttribute('href', href);
      link.dataset.awPostpurchaseLoginReturn = 'true';
    });
  };

  const ensureNotice = (entry) => {
    document.querySelectorAll('[data-aw-postpurchase-entry-notice]').forEach((node) => node.remove());
    if (!entry || !NOTICE_COPY[entry]) return;
    const intro = document.querySelector('[data-aw-postpurchase] .aw-postpurchase__intro');
    if (!intro) return;
    const notice = document.createElement('div');
    notice.className = 'aw-postpurchase__entry';
    notice.dataset.awPostpurchaseEntryNotice = entry;
    notice.setAttribute('role', 'status');
    notice.innerHTML = '<span>APRÈS COMMANDE</span><strong></strong>';
    const strong = notice.querySelector('strong');
    if (strong) strong.textContent = NOTICE_COPY[entry];
    intro.insertAdjacentElement('afterend', notice);
  };

  const scrubPublicSourceHints = () => {
    document.querySelectorAll('[data-aw-shopify-order-item][data-source]').forEach((node) => {
      node.removeAttribute('data-source');
    });
  };

  const prioritizePostPurchaseTab = (entry) => {
    if (!entry) return;
    const root = document.querySelector('[data-aw-atelier]');
    const nav = root?.querySelector('.aw-atelier__tabs');
    const purchases = nav?.querySelector('[data-aw-atelier-tab="recommendations"]');
    if (nav && purchases && nav.firstElementChild !== purchases) nav.prepend(purchases);
  };

  const prioritizePostPurchaseStats = (entry) => {
    if (!entry) return;
    const root = document.querySelector('[data-aw-atelier]');
    const stats = root?.querySelector('.aw-atelier__stats');
    if (!stats) return;
    const cards = [...stats.querySelectorAll(':scope > article')];
    const byLabel = (label) => cards.find((card) => (card.querySelector('span')?.textContent || '').trim() === label);
    ['Commandes AW', 'Dernière activité', 'Projets', 'Valeur'].forEach((label) => {
      const card = byLabel(label);
      if (card) stats.append(card);
    });
    root.dataset.awPostpurchaseStats = 'orders-first';
  };

  const adaptPostPurchaseHero = (entry) => {
    if (!entry) return;
    const root = document.querySelector('[data-aw-atelier]');
    const hero = root?.querySelector('.aw-atelier__hero');
    if (!root || !hero) return;
    const eyebrow = hero.querySelector('header p, :scope > div:first-child > p');
    const heading = hero.querySelector('h1');
    const intro = hero.querySelector('.rte');
    if (eyebrow) eyebrow.textContent = 'MON ATELIER · APRÈS COMMANDE';
    if (heading) heading.textContent = 'Retrouvez vos achats et leur suivi AW';
    if (intro) intro.textContent = 'Votre commande ouvre Mon Atelier : retrouvez vos achats Airsoft, leur modèle exact lorsqu’il est documenté, et les vérifications ou interventions disponibles.';
    root.dataset.awPostpurchaseHero = 'true';
  };

  const focusPostPurchaseLogin = (entry) => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return;
    const loginLink = root.querySelector('[data-aw-postpurchase-empty] [data-aw-postpurchase-login-return="true"]');
    if (entry && loginLink) root.dataset.awPostpurchaseFocus = 'login';
    else delete root.dataset.awPostpurchaseFocus;
  };

  const adaptPostPurchaseRelay = (entry) => {
    if (!entry) return;
    const relay = document.querySelector('.aw14-bridge');
    if (!relay) return;
    relay.dataset.awPostpurchaseRelay = 'true';
    const eyebrow = relay.querySelector('.aw14-eyebrow');
    const heading = relay.querySelector('h2');
    const description = heading?.parentElement?.querySelector('p:not(.aw14-eyebrow)');
    if (eyebrow) eyebrow.textContent = 'APRÈS VOTRE COMMANDE';
    if (heading) heading.textContent = 'BESOIN D’UNE INTERVENTION OU D’UNE VÉRIFICATION ?';
    if (description) description.textContent = 'Partez de votre achat : vérifiez la correspondance exacte ou consultez les prestations Atelier adaptées à votre réplique.';
  };

  const makeGarageOptional = (entry) => {
    const garage = document.querySelector('[data-aw-garage-p2]');
    const existingShell = document.querySelector('[data-aw-postpurchase-garage-toggle]');
    if (!garage) return;

    if (!entry) {
      if (garage.dataset.awPostpurchaseOptional === 'true') garage.hidden = false;
      existingShell?.remove();
      delete garage.dataset.awPostpurchaseOptional;
      return;
    }

    garage.id = garage.id || 'aw-postpurchase-optional-garage';
    garage.dataset.awPostpurchaseOptional = 'true';

    if (existingShell) return;

    garage.hidden = true;
    const shell = document.createElement('div');
    shell.className = 'page-width aw-postpurchase__optional-garage-shell';
    shell.dataset.awPostpurchaseGarageToggle = 'true';
    shell.innerHTML = `
      <div class="aw-postpurchase__optional-garage">
        <div>
          <span>OPTIONNEL</span>
          <strong>Garage</strong>
          <p>Le Garage reste disponible pour vos équipements et Builds, mais il n’est pas nécessaire pour suivre une commande dans Mon Atelier.</p>
        </div>
        <button type="button" aria-controls="${garage.id}" aria-expanded="false">Afficher le Garage</button>
      </div>`;
    garage.insertAdjacentElement('beforebegin', shell);

    const button = shell.querySelector('button');
    button?.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      garage.hidden = !expanded;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? 'Masquer le Garage' : 'Afficher le Garage';
      try {
        window.AWAnalytics?.track?.('mon_atelier_postpurchase_garage_toggle', { entry, expanded });
      } catch (_) {}
    });
  };

  const trackLandingState = (entry) => {
    if (!entry) return;
    const root = document.querySelector('[data-aw-atelier]');
    if (!root || root.dataset.awPostpurchaseLandingTracked === 'true') return;
    const sample = () => {
      if (root.dataset.awPostpurchaseLandingTracked === 'true') return;
      const orderCount = Math.max(0, Number(root.dataset.awPostpurchaseOrderCount || 0));
      const loginRequired = Boolean(root.querySelector('[data-aw-postpurchase-login-return="true"]'));
      const emptyVisible = Boolean(root.querySelector('[data-aw-postpurchase-empty]:not([hidden])'));
      const state = orderCount > 0
        ? 'orders_ready'
        : loginRequired
          ? 'login_required'
          : emptyVisible
            ? 'no_orders'
            : '';
      if (!state) return;
      root.dataset.awPostpurchaseLandingTracked = 'true';
      try {
        window.AWAnalytics?.track?.('mon_atelier_postpurchase_landing_state', {
          entry,
          state,
          has_orders: orderCount > 0
        });
      } catch (_) {}
    };
    window.setTimeout(sample, 450);
    window.setTimeout(sample, 1200);
  };

  const bindRelayTracking = (entry) => {
    if (!entry) return;
    const relay = document.querySelector('.aw14-bridge[data-aw-postpurchase-relay="true"]');
    if (!relay) return;
    relay.querySelectorAll('a').forEach((link) => {
      if (link.dataset.awPostpurchaseRelayTracked === 'true') return;
      link.dataset.awPostpurchaseRelayTracked = 'true';
      link.addEventListener('click', () => {
        const href = String(link.getAttribute('href') || '');
        const target = href.includes('compatibilite-airsoft')
          ? 'compatibility'
          : href.includes('notre-atelier-de-preparation-de-repliques-airsoft')
            ? 'atelier'
            : 'other';
        try {
          window.AWAnalytics?.track?.('mon_atelier_postpurchase_relay_click', { entry, target });
        } catch (_) {}
      });
    });
  };

  const bindLoginTracking = (entry) => {
    document.querySelectorAll('[data-aw-postpurchase-login-return="true"]').forEach((link) => {
      if (link.dataset.awPostpurchaseLoginTracked === 'true') return;
      link.dataset.awPostpurchaseLoginTracked = 'true';
      link.addEventListener('click', () => {
        try {
          window.AWAnalytics?.track?.('mon_atelier_postpurchase_login_click', {
            entry: entry || 'login_return'
          });
        } catch (_) {}
      });
    });
  };

  const run = () => {
    const entry = getEntry();
    applyLoginReturn(entry);
    scrubPublicSourceHints();
    prioritizePostPurchaseTab(entry);
    prioritizePostPurchaseStats(entry);
    adaptPostPurchaseHero(entry);
    focusPostPurchaseLogin(entry);
    adaptPostPurchaseRelay(entry);
    makeGarageOptional(entry);
    ensureNotice(entry);
    bindLoginTracking(entry);
    bindRelayTracking(entry);
    trackLandingState(entry);
    if (entry) track(entry);
  };

  window.AWMonAtelierEntrySourceP1 = {
    version: VERSION,
    run,
    getEntry,
    allowed: [...ALLOWED]
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();
